(() => {
	const loadCustomScripts = () => {
		window.custom_scripts.forEach((script) => {
				let s = document.createElement("script");
				s.setAttribute("src", script);
				document.head.insertAdjacentElement("beforeend", s);
		});
	};
	const loadLanguageDetect = () => {
		const languageIsDetected = localStorage.getItem("languageIsDetected");
		if (languageIsDetected) {
			return;
		} else {
			document
				.querySelector("localization-form-header")
				.dispatchEvent(new Event("language-detect"));
		}
	};
	const loadGTag = () => {
		let a = document.createElement("script");
		a.setAttribute(
			"src",
			"https://www.googletagmanager.com/gtag/js?id=AW-665713515"
		);

		a.onload = () => {
			window.dataLayer = window.dataLayer || [];
			function gtag() {
				dataLayer.push(arguments);
			}
			gtag("js", new Date());

			gtag("config", "AW-665713515");
		};
		document.head.insertAdjacentElement("beforeend", a);

		(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({
				"gtm.start": new Date().getTime(),
				event: "gtm.js",
			});
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l != "dataLayer" ? "&l=" + l : "";
			j.async = true;
			j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
			f.parentNode.insertBefore(j, f);
		})(window, document, "script", "dataLayer", "GTM-KBF72FB");
	};
	const showNavSwitcherIcon = () => {
		document.querySelectorAll("[data-hidden-caret]").forEach((item) => {
			item.setAttribute("data-hidden-caret", "false");
		});
	};

	const loadMicrosoftClarity = () => {
		let a = document.createElement("script");
		a.type = "text/javascript";
		a.async = true;
		a.textContent = `(function(c,l,a,r,i,t,y){ c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)}; t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i; y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y); })(window, document, "clarity", "script", "ggti11oc4s");`;
		document.head.insertAdjacentElement("beforeend", a);
	};
	const loadFilterTracking = () => {
		let a = document.createElement("script");
		a.textContent = `
		if (window.matchMedia("(max-width: 767.9px)").matches) {
			document.querySelector('#main-collection-filters').addEventListener('click', function(){
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
				'event': 'collection_filter_open'
				});
			})
		}
		`;
		a.defer = true;
		document.querySelector("body").insertAdjacentElement("beforeend", a);
	};
	const initializeAnnouncementSwiper = () => {
		let b = document.createElement("link")
		b.setAttribute("rel", "stylesheet")
		b.setAttribute("href", "https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css")
		document.querySelector("head").insertAdjacentElement("beforeend", b)
	}

	const loadScripts = () => {
		loadGTag();
		loadCustomScripts();
		showNavSwitcherIcon();
		loadLanguageDetect();
		loadMicrosoftClarity();
		loadFilterTracking();
		initializeAnnouncementSwiper()
	};

	document.addEventListener("UserInteracted", loadScripts, false);
})();
